import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuPositionerProps extends PartProps<BaseContextMenu.Positioner.Props> {
  className?: string
}

function ContextMenuPositioner({ className, children, sideOffset = 4, ...props }: ContextMenuPositionerProps) {
  return (
    <BaseContextMenu.Positioner className={twMerge('z-50 outline-none', className)} sideOffset={sideOffset} {...props}>
      {children}
    </BaseContextMenu.Positioner>
  )
}

export { ContextMenuPositioner }
